import React from 'react';
export function Hero({
  onBuyClick
}: {
  onBuyClick: () => void;
}) {
  return <section className="relative pt-[90px] pb-[80px] sm:pt-[100px] sm:pb-[100px] px-5 overflow-hidden" data-id="element-189">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.shopify.com/s/files/1/0981/0781/8286/files/01_Momento_tranquilo_en_la_tarde.png?v=1775530363)'
    }} data-id="element-190"></div>
      <div className="absolute inset-0 bg-black/60" data-id="element-191"></div>

      <div className="max-w-[900px] mx-auto relative z-10 text-center" data-id="element-192">
        {/* Price Badge */}
        <div className="inline-block bg-[#F9C74F] text-black font-black text-sm sm:text-base px-5 py-2 rounded-full mb-6 shadow-lg animate-pulse" data-id="element-193">
          ⚡ OFERTA FLASH: $14
        </div>

        <h1 className="text-[clamp(28px,5vw,48px)] font-black leading-[1.15] text-white mb-6 font-montserrat drop-shadow-lg" data-id="element-194">
          Toma el Control de tu{' '}
          <span className="inline-block" data-id="element-195">
            <span className="text-[#B22234]" data-id="element-196">Sueño</span>{' '}
            <span className="text-[#FFFFFF]" data-id="element-197">Ameri</span>
            <span className="text-[#3C3B6E]" data-id="element-198">cano</span>
          </span>{' '}
          por menos de lo que cuesta un almuerzo
        </h1>

        <h2 className="text-[clamp(16px,3vw,20px)] text-white/90 mb-8 leading-[1.6] font-medium max-w-[750px] mx-auto drop-shadow-md" data-id="element-199">
          El método táctico para poner tus cuentas al día y blindar tu futuro.
          Resultados este mismo viernes por solo{' '}
          <strong className="text-yellow-300 font-black" data-id="element-200">$14</strong>.
        </h2>

        <button onClick={onBuyClick} className="btn-buy-main block w-full max-w-md mx-auto text-white text-lg sm:text-xl font-black py-5 px-6 uppercase tracking-wide text-center cursor-pointer border-none min-h-[54px] animate-[btnPulse_2s_ease-in-out_infinite]" data-id="element-201">
          SÍ, QUIERO EL SISTEMA POR $14
        </button>

        <p className="text-white/50 text-xs mt-3" data-id="element-202">
          🔒 Pago seguro · Descarga inmediata · Garantía 7 días
        </p>

        {/* Sello de Pago Seguro */}
        <div className="flex items-center justify-center gap-3 mt-5 flex-wrap" data-id="element-203">
          <div className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg px-3 py-2" data-id="element-204">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-205">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-206" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-207" />
            </svg>
            <span className="text-white/70 text-[10px] sm:text-xs font-bold tracking-wide" data-id="element-208">
              SSL SEGURO
            </span>
          </div>
          <div className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg px-3 py-2" data-id="element-209">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#a78bfa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-210">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2" data-id="element-211" />
              <line x1="1" y1="10" x2="23" y2="10" data-id="element-212" />
            </svg>
            <span className="text-white/70 text-[10px] sm:text-xs font-bold tracking-wide" data-id="element-213">
              STRIPE
            </span>
          </div>
          <div className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg px-3 py-2" data-id="element-214">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-215">
              <path d="M6.5 8C4 8 2 10 2 12.5S4 17 6.5 17h11c2.5 0 4.5-2 4.5-4.5S20 8 17.5 8" data-id="element-216" />
              <path d="M9 12h6" data-id="element-217" />
            </svg>
            <span className="text-white/70 text-[10px] sm:text-xs font-bold tracking-wide" data-id="element-218">
              PAYPAL
            </span>
          </div>
        </div>
      </div>
    </section>;
}